import { Notifications } from '@orbitalgaming/games-frontend-library'

export const copyToClipboard = (
  e: any,
  setisTarget?: any,
  handleNotification?: any,
) => {
  e.target.select()
  setisTarget(e.target.value)
  document.execCommand('copy')
  handleNotification(Notifications.copied)
}
